import React from 'react';
import ScreenshotCaptureRow from './ScreenshotCaptureRow';
import CJLogo from '../Logo/CJLogo';

export default ({ offer }) => (
  <ScreenshotCaptureRow offer={offer}>{offer.isCJOffer && <CJLogo />}</ScreenshotCaptureRow>
);
